import React, { useEffect, useRef, useState } from 'react'; 
import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
const timelineData = [
  {
    date: 'December 05, 2021',
    time: '10:30AM',
    content: 'Yeh pehla content hai. Yeh pehla content hai. Yeh pehla content hai. Yeh pehla content hai. Yeh pehla content hai. Yeh pehla content hai. Yeh pehla content hai. Yeh pehla content hai. Yeh pehla content hai. ',
    position: 'left',
    email: 'ami@acadereality.com', // Dynamic Email
    designation: 'BDE', // Dynamic Designation
    datetime: '21-09-2022, 12:31PM', // Dynamic Date and Time
    attachment: 'NA' // Dynamic Attachment
  },
  {
    date: 'February 10, 2022',
    time: '10:30AM',
    content: 'Yeh doosra content hai.Yeh doosra content hai.Yeh doosra content hai.',
    position: 'right',
    email: 'john@acadereality.com',
    designation: 'Manager',
    datetime: '10-02-2022, 09:15AM',
    attachment: 'Report.pdf'
  },
  {
    date: 'February 10, 2022',
    time: '10:30AM',
    content: 'Yeh doosra content hai.',
    position: 'left',
    email: 'john@acadereality.com',
    designation: 'Manager',
    datetime: '10-02-2022, 09:15AM',
    attachment: 'Report.pdf'
  },
  {
    date: 'February 10, 2022',
    time: '10:30AM',
    content: 'Yeh doosra content hai.',
    position: 'right',
    email: 'john@acadereality.com',
    designation: 'Manager',
    datetime: '10-02-2022, 09:15AM',
    attachment: 'Report.pdf'
  },
  {
    date: 'February 10, 2022',
    time: '10:30AM',
    content: 'Yeh doosra content hai.',
    position: 'left',
    email: 'john@acadereality.com',
    designation: 'Manager',
    datetime: '10-02-2022, 09:15AM',
    attachment: 'Report.pdf'
  },
  {
    date: 'February 10, 2022',
    time: '10:30AM',
    content: 'Yeh doosra content hai.',
    position: 'right',
    email: 'john@acadereality.com',
    designation: 'Manager',
    datetime: '10-02-2022, 09:15AM',
    attachment: 'Report.pdf'
  },
  // Add more entries as needed
];

const FeedBackLog = () => {

    // Date custom strat
    const [startDate, setStartDate] = useState('');
    const dateInputRef = useRef(null);  // Create a ref for the input
    useEffect(() => {
      // Initialize flatpickr with date and time
      flatpickr(dateInputRef.current, {
        enableTime: true,  // Enable time picker
        noCalendar: false,  // Make sure the calendar is enabled (for date selection)
        dateFormat: "m/d/Y h:i K",  // Date and time format: MM/DD/YYYY HH:MM AM/PM
        time_24hr: false,  // Optional: switch to 24-hour format if needed
        onChange: (selectedDates, dateStr) => {
          setStartDate(dateStr);  // Update the date and time state
        }
      });
    }, []);

    // File upload

  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    // Filter to include only zip files
    const zipFiles = files.filter(file => file.type === 'application/zip');
    setSelectedFiles((prevFiles) => [...prevFiles, ...zipFiles]);
  };

  const handleFileRemove = (indexToRemove) => {
    setSelectedFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove)
    );
  };


  return (
    <> 
    <div className="card h-100 p-0 radius-12">
            <div className="card-body p-24">
              <div className="row">
                <div className="col-md-12">
                  <div className="d-flex justify-content-between align-items-center mb-24"> 
                    <ul className="D_pdtls"> 
                      <li className="fw-semibold text-neutral-400  text-md mb-8"><span className="D_pdtlsName text-primary-light">Project Code</span><span className="ColnNmb">:</span> E</li>
                      <li className="fw-semibold text-neutral-400 text-md mb-8"><span className="D_pdtlsName text-primary-light">Project Manager</span><span className="ColnNmb">:</span> Sandeep Dubey</li>
                      <li className="fw-semibold text-neutral-400 text-md mb-8"><span className="D_pdtlsName text-primary-light">Project Coordinator</span><span className="ColnNmb">:</span> Ahmad Monis</li>
                    </ul>
                    <div className="text-end"> 
                    {/* <a href="" className="btn btn-sm btn-primary-600" data-bs-toggle="modal" data-bs-target="#addfeedbakc"><i className="ri-add-line"></i> Add Feedback</a> */}
                    <div className="text-sm mt-12"><span className="fw-bold">Average Response Time</span> : 30mins</div>
                    <label className="C_radioBtn C_CkeckBtn C_CkeckBtn2 mt-24 text-start">
  View All Feedback
  <input type="checkbox"  />
  <span className="checkmark" />
</label>
                    </div>
                  </div> 
                </div>  
              </div>
            <div className="row">
               <div className="col-md-12 mb-28">
                  <ul className="acadClint">
                     <li>Acadecraft</li>
                     <li>Client</li>
                  </ul>
               </div>
            </div>
            <div className="daysTxt0"><span className="daysTxt1">Days</span></div>
            <div className="timeline">
      {timelineData.map((entry, index) => (
        <div
          key={index}
          className={`FeedBackLog ${entry.position}`} // Position ko dynamically set kar rahe hain
        >
   <div className="markerdotted">0</div>
   <div className="ttmdata">
  <div className="d-flex justify-content-between">
  <label className="C_radioBtn C_CkeckBtn C_CkeckBtn2">
  Feedback
  <input type="checkbox"  />
  <span className="checkmark" />
</label>

  <h6 className="mb-2 fw-bold text-lg d-flex justify-content-end mb-12">{entry.date} {entry.time ? `(${entry.time})` : ""}</h6> 
  </div>
        <div className="content">   
  <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between mt-8">
    <h6 className="mb-2 fw-bold text-lg">Ami Sukumar</h6> 
    {/* Dynamic date from the entry object */} 
    <div className="insidecall-icon"><button type="button" className="edit text-info-600" data-toggle="modal" data-target="#view_listmdl" data-bs-toggle="modal" data-bs-target="#addfeedbakc"><i className="mdi mdi-lead-pencil"></i></button></div>
  </div>
  <div className="mt-3">
    <div className="d-flex align-items-center justify-content-between gap-3 mb-12">
      <div className="d-flex align-items-center text-nowrap">  
          Email Id
      </div>
      <div className="d-flex align-items-center justify-content-end gap-2 w-100"> 
        {/* Dynamic Email */}
        <span className="text-secondary-light font-xs fw-semibold">{entry.email}</span>
      </div>
    </div>
    <div className="d-flex align-items-center justify-content-between gap-3 mb-12">
      <div className="d-flex align-items-center text-nowrap"> 
        Designation 
      </div>
      <div className="d-flex align-items-center justify-content-end gap-2 w-100"> 
        {/* Dynamic Designation */}
        <span className="text-secondary-light font-xs fw-semibold">{entry.designation}</span>
      </div>
    </div>
    <div className="d-flex align-items-center justify-content-between gap-3 mb-12">
      <div className="d-flex align-items-center text-nowrap"> 
        Date and Time 
      </div>
      <div className="d-flex align-items-center justify-content-end gap-2 w-100"> 
        {/* Dynamic Date and Time */}
        <span className="text-secondary-light font-xs fw-semibold">{entry.datetime}</span>
      </div>
    </div>
    <div className="d-flex align-items-center justify-content-between gap-3 mb-12">
      <div className="d-flex align-items-center text-nowrap"> 
        Attachment 
      </div>
      <div className="d-flex align-items-center justify-content-end gap-2 w-100"> 
        {/* Dynamic Attachment */}
        <span className="text-secondary-light font-xs fw-semibold">{entry.attachment}</span>
      </div>
    </div>
    <div className="d-flex align-items-center justify-content-between gap-3 mb-12">
      <div className="d-flex align-items-center text-nowrap"> 
        Email Content 
      </div>
      {/* <div className="d-flex align-items-center justify-content-end gap-2 w-100">  */}
        {/* Dynamic Email Content */}
        {/* <span className="text-secondary-light font-xs fw-semibold">{entry.content}</span>  */}
      {/* </div> */}
      <div className="d-flex align-items-center justify-content-end gap-2 w-100"> 
        <span className="text-secondary-light font-xs fw-semibold">
          {/* Show only the first 10 words */}
          {entry.content.split(' ').slice(0, 2).join(' ')}
          {entry.content.split(' ').length > 2 && '...'}
        </span>
        {entry.content.split(' ').length > 2 && (
          <button className="btn btn-link p-0" data-bs-toggle="modal" data-bs-target="#fullContent">
            View
          </button>
        )}
      </div>
    </div>
  </div> 
 
        </div>
   </div>

        </div>
      ))}
    </div>
            </div>
        </div>
        <div className="modal fade cusmodl" id="addfeedbakc" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div className="modal-dialog modal-lg modal-dialog-scrollable">
            <div className="modal-content">
              <div className="modal-header d-flex justify-content-between pb-0 border-0">
                <h6 className="mb-2 fw-bold text-lg mb-0">Add Feedback</h6>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">✗</button>
                </div>
                <div className="modal-body">
                <form action="#">
  <div className="row">
    <div className="col-sm-6">
    <div className="mb-20">
        <label
          htmlFor="depart"
          className="form-label fw-semibold text-primary-light text-sm mb-8"
        >
          Email From <span className="text-danger-600">*</span>{" "}
        </label>
        <select className="form-control radius-8 form-select" id="depart">
          <option selected disabled>Select</option>
          <option>Acaecraft</option>
          <option>Client </option> 
        </select>
      </div>
    </div>
    <div className="col-sm-6">
      <div className="mb-20">
        <label
          htmlFor="EmailID"
          className="form-label fw-semibold text-primary-light text-sm mb-8"
        >
          Email ID <span className="text-danger-600">*</span>
        </label>
        <input
          type="text"
          className="form-control radius-8"
          id="EmailID"
          placeholder="Enter Email ID"
        />
      </div>
    </div>
    <div className="col-sm-6">
      <div className="mb-20">
        <label
          htmlFor="fn"
          className="form-label fw-semibold text-primary-light text-sm mb-8"
        >
          Responder Name <span className="text-danger-600">*</span>
        </label>
       <div className="d-flex gap-2">
       <input
          type="text"
          className="form-control radius-8"
          id="fn"
          placeholder="Enter First Name"
        />
         <input
          type="text"
          className="form-control radius-8"
          id="ln"
          placeholder="Enter Last Name"
        />
       </div>
      </div>
    </div> 
    <div className="col-sm-6">
      <div className="mb-20">
        <label
          htmlFor="ln"
          className="form-label fw-semibold text-primary-light text-sm mb-8"
        >
          Date & Time <span className="text-danger-600">*</span>
        </label>
        <div className="position-relative">
        <input
    className="form-control radius-8 bg-base"
    id="editstartDate"
    type="text"
    placeholder="MM/DD/YYYY HH:MM"
    ref={dateInputRef}  // Attach ref to the input
    value={startDate}
    onChange={(e) => setStartDate(e.target.value)}  // This is optional but can help with manual input
  />
  <span className="position-absolute end-0 top-50 translate-middle-y me-12 line-height-1">
    <iconify-icon icon="solar:calendar-linear" className="icon text-lg"></iconify-icon>
  </span>
                  </div>
      </div>
    </div>

    <div className="col-sm-6">
      <div className="mb-20">
        <label
          htmlFor="Designation"
          className="form-label fw-semibold text-primary-light text-sm mb-8"
        >
          Responder Designation <span className="text-danger-600">*</span>
        </label>
        <input
          type="text"
          className="form-control radius-8"
          id="Designation"
          placeholder="Enter Designation"
        />
      </div>
    </div>
    <div className="col-sm-6">
      <div className="mb-20">
        <label
          htmlFor="Designation"
          className="form-label fw-semibold text-primary-light text-sm mb-8"
        >
          Attachment <span className="text-danger-600">*</span>
        </label>
          
                    <div className="attchProMaine mt-0">
                      <input
                        type="file"
                        name="file"
                        id="file" className="from-control"
                        multiple
                        accept=".zip"  // Only allows ZIP files
                        onChange={handleFileChange}
                      />
                      <label htmlFor="file">
                        <div className="attContent">+ Attachment {" "}
                          <span>
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M14.4888 6.85102L8.16811 13.1709C7.4703 13.8935 6.52074 14.3192 5.51701 14.3595C4.51328 14.3997 3.53268 14.0514 2.77923 13.387C2.41132 13.0406 2.11674 12.6238 1.91297 12.1614C1.70921 11.699 1.6004 11.2004 1.59302 10.6951C1.58563 10.1898 1.67982 9.68821 1.86999 9.22003C2.06016 8.75186 2.34244 8.32665 2.70007 7.96964L8.0834 2.58631C8.50784 2.17421 9.07738 1.94564 9.66896 1.95001C10.2605 1.95437 10.8266 2.19131 11.245 2.60962C11.6633 3.02794 11.9002 3.59405 11.9046 4.18563C11.9089 4.7772 11.6804 5.34674 11.2683 5.77119L5.88494 11.1545C5.74607 11.2864 5.56187 11.3599 5.37036 11.3599C5.17885 11.3599 4.99465 11.2864 4.85578 11.1545C4.72041 11.0175 4.6445 10.8326 4.6445 10.6399C4.6445 10.4473 4.72041 10.2624 4.85578 10.1254L9.16007 5.82106C9.30872 5.67157 9.3919 5.46914 9.39131 5.25832C9.39071 5.0475 9.3064 4.84555 9.1569 4.69689C9.00741 4.54824 8.80499 4.46506 8.59416 4.46565C8.38334 4.46625 8.18139 4.55057 8.03273 4.70006L3.72844 9.00277C3.29543 9.43712 3.05228 10.0254 3.05228 10.6387C3.05228 11.2521 3.29543 11.8404 3.72844 12.2747C4.16908 12.6954 4.75484 12.9301 5.36403 12.9301C5.97321 12.9301 6.55897 12.6954 6.99961 12.2747L12.3829 6.89139C12.745 6.5364 13.033 6.11315 13.2304 5.64613C13.4278 5.17911 13.5307 4.67759 13.533 4.17057C13.5354 3.66355 13.4372 3.16109 13.2441 2.69226C13.0511 2.22342 12.767 1.79752 12.4083 1.43918C12.0495 1.08084 11.6234 0.797178 11.1543 0.604594C10.6853 0.41201 10.1827 0.314329 9.67572 0.3172C9.1687 0.320072 8.66728 0.423439 8.20046 0.621323C7.73364 0.819207 7.31069 1.10768 6.95607 1.47006L1.57273 6.85339C1.06542 7.36045 0.665137 7.96425 0.395625 8.62896C0.126113 9.29366 -0.00713247 10.0057 0.00379549 10.7229C0.0147234 11.4401 0.169602 12.1478 0.459241 12.804C0.74888 13.4602 1.16738 14.0515 1.6899 14.5429C2.67042 15.4541 3.96298 15.9547 5.30148 15.9417C6.79668 15.9413 8.23048 15.347 9.28753 14.2895L15.6082 7.96885C15.6838 7.89582 15.7441 7.80847 15.7856 7.71188C15.8271 7.61529 15.8489 7.51141 15.8499 7.40629C15.8508 7.30118 15.8307 7.19693 15.7909 7.09964C15.7511 7.00234 15.6923 6.91395 15.618 6.83962C15.5437 6.76529 15.4553 6.70651 15.358 6.6667C15.2607 6.6269 15.1565 6.60686 15.0513 6.60778C14.9462 6.60869 14.8423 6.63053 14.7457 6.67202C14.6492 6.71351 14.5618 6.77382 14.4888 6.84943V6.85102Z"
                                fill="#CC33FF"
                              />
                            </svg></span></div>
                      </label>
                    </div>
                  
      </div>
    </div>
    
        <div className="col-sm-12">
        <div className="d-block w-100">
                {/* Display File Info Section */}
                {selectedFiles.length > 0 &&
                  selectedFiles.map((file, index) => (
                    <div className="clientDocShow clientDocShowNeFile my-4" key={index}>
                      <div className="cleDocContent">
                        <div className="d-flex align-items-start gap-1">
                          <div className="fileFormat">
                            <span className="bgFilesg">
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="40"
                                height="40"
                                fill="currentColor"
                                className="bi bi-file-earmark-fill"
                                viewBox="0 0 16 16"
                              >
                                <path d="M4 0h5.293A1 1 0 0 1 10 .293L13.707 4a1 1 0 0 1 .293.707V14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2m5.5 1.5v2a1 1 0 0 0 1 1h2z"></path>
                              </svg>
                            </span>
                            <span className="filefmttext">ZIP</span>
                          </div>
                          <div>
                            <div className="FileName">{file.name}</div>
                            <div className="FileSize">
                              {(file.size / 1024).toFixed(2)} KB
                            </div>
                          </div>
                        </div>
                        <button
                          className="deletFilebtn px-3 py-3 d-flex justify-content-center align-items-center"
                          onClick={() => handleFileRemove(index)}
                        >
                          <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M3.30775 17.4997C2.81058 17.4997 2.385 17.3227 2.031 16.9687C1.677 16.6147 1.5 16.1892 1.5 15.692V2.99973H1.25C1.0375 2.99973 0.859417 2.92782 0.71575 2.78398C0.571917 2.64015 0.5 2.46198 0.5 2.24948C0.5 2.03682 0.571917 1.85873 0.71575 1.71523C0.859417 1.57157 1.0375 1.49973 1.25 1.49973H5C5 1.2549 5.08625 1.04624 5.25875 0.873735C5.43108 0.701402 5.63967 0.615234 5.8845 0.615234H10.1155C10.3603 0.615234 10.5689 0.701402 10.7413 0.873735C10.9138 1.04624 11 1.2549 11 1.49973H14.75C14.9625 1.49973 15.1406 1.57165 15.2843 1.71548C15.4281 1.85932 15.5 2.03748 15.5 2.24998C15.5 2.46265 15.4281 2.64073 15.2843 2.78423C15.1406 2.9279 14.9625 2.99973 14.75 2.99973H14.5V15.692C14.5 16.1892 14.323 16.6147 13.969 16.9687C13.615 17.3227 13.1894 17.4997 12.6923 17.4997H3.30775ZM13 2.99973H3V15.692C3 15.7818 3.02883 15.8556 3.0865 15.9132C3.14417 15.9709 3.21792 15.9997 3.30775 15.9997H12.6923C12.7821 15.9997 12.8558 15.9709 12.9135 15.9132C12.9712 15.8556 13 15.7818 13 15.692V2.99973ZM6.15425 13.9997C6.36675 13.9997 6.54483 13.9279 6.6885 13.7842C6.832 13.6404 6.90375 13.4622 6.90375 13.2497V5.74973C6.90375 5.53723 6.83183 5.35907 6.688 5.21523C6.54433 5.07157 6.36617 4.99973 6.1535 4.99973C5.941 4.99973 5.76292 5.07157 5.61925 5.21523C5.47575 5.35907 5.404 5.53723 5.404 5.74973V13.2497C5.404 13.4622 5.47583 13.6404 5.6195 13.7842C5.76333 13.9279 5.94158 13.9997 6.15425 13.9997ZM9.8465 13.9997C10.059 13.9997 10.2371 13.9279 10.3807 13.7842C10.5243 13.6404 10.596 13.4622 10.596 13.2497V5.74973C10.596 5.53723 10.5242 5.35907 10.3805 5.21523C10.2367 5.07157 10.0584 4.99973 9.84575 4.99973C9.63325 4.99973 9.45517 5.07157 9.3115 5.21523C9.168 5.35907 9.09625 5.53723 9.09625 5.74973V13.2497C9.09625 13.4622 9.16817 13.6404 9.312 13.7842C9.45567 13.9279 9.63383 13.9997 9.8465 13.9997Z" fill="#1C1B1F"></path>
                          </svg>
                        </button>
                      </div>
                    </div>
                  ))}

              </div>
        </div>
      
    <div className="col-sm-12">
      <div className="mb-20">
        <label
          htmlFor="desc"
          className="form-label fw-semibold text-primary-light text-sm mb-8"
        >
          Email Content
        </label>
        <textarea
          name="#0"
          className="form-control radius-8"
          id="desc"
          placeholder="Write Email Content..."
          defaultValue={""}
        />
      </div>
    </div>
  </div>
  <div className="d-flex align-items-center justify-content-center gap-3">
    <button
      type="button"
      className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-56 py-11 radius-8"
    >
      Cancel
    </button>
    <button
      type="button"
      className="btn btn-primary border border-primary-600 text-md px-56 py-12 radius-8"
    >
      Save
    </button>
  </div>
</form>

                  </div>
                  </div></div></div>

                    {/* Modal to show full content */}
                    {timelineData.map((entry, index) => (
    <div className="modal fade cusmodl" id="fullContent" tabindex="-1" aria-labelledby="exampleModalLabel2" aria-hidden="true">
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header d-flex justify-content-between border-bottom-0">
          <h6 className="mb-2 fw-bold text-lg mb-0">Full Content</h6> 
            <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">✗</button>
          </div>
          <div className="modal-body">
            <p>{entry.content}</p>
          </div> 
        </div>
      </div>
    </div>
                    ))}
   </>
  );
};

export default FeedBackLog;
